import {
  TracksFill24Icon,
  TracksOutline24Icon,
  WarningFill24Icon,
} from "@vygruppen/spor-icon-react";
import styled from "styled-components";

const IconContainer = styled.span`
  position: relative;
  display: flex;
  max-width: min-content;
`;

const StyledWarningIcon = styled(WarningFill24Icon)`
  position: absolute;
  right: -5px;
  bottom: -3px;
`;

export const InfrastructureIncidentIcon24 = () => (
  <IconContainer>
    <TracksOutline24Icon />
    <StyledWarningIcon height="16px" fill="black" />
  </IconContainer>
);

export const InfrastructureIncidentIconTabsActive24 = () => (
  <IconContainer>
    <TracksFill24Icon />
    <StyledWarningIcon height="16px" fill="black" />
  </IconContainer>
);
